var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _g, _path22, _g2, _path23, _g3, _path24, _g4, _path25, _g5, _path26, _g6, _path27, _g7, _path28;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoLarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 214,
    height: 168,
    viewBox: "0 0 214 168",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.8801 131.434H30.8374V130H36.8374V131.434H34.8029V142H32.8801V131.434Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.8374 130H49.7599V131.434H46.8529V135.023H49.099V136.457H46.8529V140.568H49.8374V142H44.8374V130Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.5015 142C61.331 142 61.1463 141.985 60.9474 141.956C60.7485 141.925 60.5481 141.861 60.3492 141.765C60.1503 141.668 59.9599 141.531 59.7794 141.355C59.5976 141.176 59.4356 140.944 59.2963 140.654C59.1585 140.363 59.0463 140.006 58.9624 139.579C58.88 139.154 58.8374 138.645 58.8374 138.057V133.88C58.8374 133.287 58.8814 132.778 58.9667 132.357C59.052 131.936 59.1656 131.583 59.3063 131.294C59.447 131.007 59.6103 130.778 59.7951 130.607C59.9784 130.437 60.1687 130.307 60.3662 130.217C60.5623 130.128 60.7584 130.069 60.9531 130.041C61.1477 130.014 61.3296 130 61.4958 130C61.932 130 62.2972 130.066 62.5899 130.196C62.884 130.327 63.1184 130.507 63.2961 130.735C63.4737 130.963 63.6001 131.229 63.6754 131.531C63.7493 131.835 63.7863 132.159 63.7863 132.499C63.7863 132.752 63.7749 132.986 63.7522 133.2C63.7294 133.414 63.6925 133.65 63.6456 133.908H62.2986V133.307C62.2986 132.658 62.2304 132.172 62.0997 131.851C61.9661 131.528 61.7715 131.366 61.5143 131.366C61.3608 131.366 61.2259 131.398 61.1094 131.464C60.9957 131.528 60.8991 131.638 60.8223 131.791C60.7456 131.945 60.6859 132.149 60.6462 132.402C60.6035 132.656 60.5836 132.971 60.5836 133.348V138.734C60.5836 139.102 60.5993 139.408 60.6319 139.653C60.6646 139.897 60.7172 140.093 60.7897 140.238C60.8621 140.386 60.9573 140.49 61.0753 140.553C61.1932 140.615 61.3353 140.646 61.5015 140.646C61.6095 140.646 61.7118 140.62 61.8098 140.566C61.9079 140.513 61.996 140.43 62.0699 140.317C62.1452 140.204 62.2048 140.064 62.2503 139.891C62.2944 139.717 62.3171 139.515 62.3171 139.278V138.126H63.8374V139.217C63.8374 140.166 63.6371 140.864 63.235 141.315C62.8329 141.768 62.2546 141.994 61.5015 142Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.8374 130H73.7226V135.023H75.9555V130H77.8374V142H75.9555V136.457H73.7226V142H71.8374V130Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.8374 130H88.3465L91.3203 138.03H91.3632C91.3489 137.843 91.3314 137.636 91.306 137.406C91.2821 137.176 91.2615 136.914 91.2424 136.622C91.2217 136.328 91.2058 135.997 91.1915 135.627C91.1772 135.258 91.1692 134.841 91.1692 134.376V130H92.8374V142H91.3139L88.3545 134.18H88.2957C88.31 134.392 88.3306 134.621 88.3545 134.866C88.3768 135.112 88.399 135.401 88.4197 135.734C88.4372 136.067 88.4531 136.454 88.469 136.896C88.4817 137.339 88.4897 137.865 88.4897 138.474V142H86.8374V130Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.852 140.654C105.032 140.654 105.189 140.623 105.322 140.563C105.457 140.502 105.571 140.4 105.655 140.253C105.743 140.105 105.811 139.911 105.855 139.669C105.9 139.428 105.922 139.122 105.922 138.754V133.39C105.922 133.012 105.9 132.697 105.855 132.444C105.811 132.19 105.743 131.987 105.655 131.832C105.571 131.678 105.457 131.57 105.322 131.504C105.189 131.441 105.032 131.408 104.852 131.408C104.668 131.408 104.506 131.441 104.37 131.504C104.233 131.57 104.118 131.678 104.029 131.832C103.938 131.987 103.872 132.19 103.826 132.444C103.782 132.697 103.76 133.012 103.76 133.39V138.754C103.76 139.122 103.782 139.428 103.826 139.669C103.872 139.911 103.938 140.105 104.029 140.253C104.118 140.4 104.233 140.502 104.37 140.563C104.506 140.623 104.668 140.654 104.852 140.654ZM104.852 142C104.658 142 104.447 141.985 104.22 141.956C103.993 141.925 103.768 141.861 103.547 141.765C103.324 141.668 103.111 141.531 102.905 141.354C102.699 141.176 102.517 140.942 102.359 140.654C102.2 140.363 102.074 140.006 101.98 139.579C101.884 139.154 101.837 138.645 101.837 138.057V133.88C101.837 133.286 101.886 132.778 101.983 132.357C102.079 131.936 102.209 131.583 102.37 131.294C102.53 131.007 102.713 130.778 102.919 130.607C103.125 130.437 103.34 130.307 103.564 130.217C103.789 130.128 104.013 130.069 104.235 130.041C104.457 130.014 104.663 130 104.852 130C105.032 130 105.231 130.012 105.451 130.038C105.671 130.063 105.891 130.118 106.111 130.203C106.33 130.289 106.544 130.416 106.753 130.584C106.96 130.752 107.145 130.98 107.305 131.267C107.465 131.554 107.596 131.912 107.691 132.337C107.789 132.763 107.837 133.277 107.837 133.88V138.057C107.837 138.641 107.789 139.144 107.688 139.565C107.589 139.986 107.459 140.343 107.297 140.637C107.137 140.929 106.952 141.163 106.742 141.34C106.531 141.517 106.316 141.655 106.096 141.754C105.877 141.853 105.657 141.919 105.44 141.951C105.224 141.983 105.027 142 104.852 142Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.837 130H118.531V140.568H120.837V142H116.837V130Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M131.852 140.654C132.032 140.654 132.189 140.623 132.322 140.563C132.457 140.502 132.571 140.4 132.655 140.253C132.743 140.105 132.811 139.911 132.855 139.669C132.9 139.428 132.922 139.122 132.922 138.754V133.39C132.922 133.012 132.9 132.697 132.855 132.444C132.811 132.19 132.743 131.987 132.655 131.832C132.571 131.678 132.457 131.57 132.322 131.504C132.189 131.441 132.032 131.408 131.852 131.408C131.668 131.408 131.506 131.441 131.37 131.504C131.233 131.57 131.118 131.678 131.029 131.832C130.938 131.987 130.872 132.19 130.826 132.444C130.782 132.697 130.76 133.012 130.76 133.39V138.754C130.76 139.122 130.782 139.428 130.826 139.669C130.872 139.911 130.938 140.105 131.029 140.253C131.118 140.4 131.233 140.502 131.37 140.563C131.506 140.623 131.668 140.654 131.852 140.654ZM131.852 142C131.658 142 131.447 141.985 131.22 141.956C130.993 141.925 130.768 141.861 130.547 141.765C130.324 141.668 130.111 141.531 129.905 141.354C129.699 141.176 129.517 140.942 129.359 140.654C129.2 140.363 129.074 140.006 128.98 139.579C128.884 139.154 128.837 138.645 128.837 138.057V133.88C128.837 133.286 128.886 132.778 128.983 132.357C129.079 131.936 129.209 131.583 129.37 131.294C129.53 131.007 129.713 130.778 129.919 130.607C130.125 130.437 130.34 130.307 130.564 130.217C130.789 130.128 131.013 130.069 131.235 130.041C131.457 130.014 131.663 130 131.852 130C132.032 130 132.231 130.012 132.451 130.038C132.671 130.063 132.891 130.118 133.111 130.203C133.33 130.289 133.544 130.416 133.753 130.584C133.96 130.752 134.145 130.98 134.305 131.267C134.465 131.554 134.596 131.912 134.691 132.337C134.789 132.763 134.837 133.277 134.837 133.88V138.057C134.837 138.641 134.789 139.144 134.688 139.565C134.589 139.986 134.459 140.343 134.297 140.637C134.137 140.929 133.952 141.163 133.742 141.34C133.531 141.517 133.316 141.655 133.096 141.754C132.877 141.853 132.657 141.919 132.44 141.951C132.224 141.983 132.027 142 131.852 142Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M146.55 142C146.407 142 146.242 141.986 146.053 141.956C145.863 141.927 145.667 141.863 145.465 141.766C145.266 141.668 145.068 141.533 144.873 141.355C144.68 141.178 144.505 140.944 144.353 140.651C144.197 140.359 144.075 140 143.979 139.574C143.885 139.149 143.837 138.641 143.837 138.052V133.877C143.837 133.285 143.886 132.776 143.987 132.356C144.086 131.934 144.219 131.581 144.384 131.292C144.549 131.005 144.739 130.776 144.956 130.605C145.172 130.437 145.395 130.306 145.627 130.217C145.858 130.127 146.088 130.067 146.314 130.04C146.542 130.012 146.753 130 146.947 130C147.439 130 147.854 130.064 148.194 130.194C148.531 130.327 148.806 130.506 149.017 130.733C149.226 130.961 149.379 131.227 149.471 131.531C149.562 131.835 149.61 132.157 149.61 132.496C149.61 132.75 149.594 132.984 149.562 133.197C149.533 133.411 149.492 133.648 149.44 133.905H147.97V133.346C147.97 132.053 147.611 131.405 146.897 131.405C146.704 131.405 146.536 131.439 146.394 131.503C146.251 131.567 146.133 131.676 146.038 131.832C145.943 131.984 145.874 132.189 145.83 132.441C145.783 132.695 145.761 133.011 145.761 133.387V138.729C145.761 139.097 145.783 139.404 145.83 139.647C145.874 139.892 145.943 140.087 146.034 140.232C146.127 140.381 146.243 140.485 146.383 140.547C146.522 140.61 146.688 140.642 146.883 140.642C147.087 140.642 147.262 140.588 147.409 140.485C147.554 140.382 147.675 140.24 147.771 140.061C147.865 139.881 147.934 139.67 147.98 139.426C148.025 139.183 148.047 138.917 148.047 138.633V137.093H147.103V135.921H149.837V141.89H148.616L148.417 140.772C148.184 141.209 147.919 141.522 147.617 141.713C147.318 141.905 146.96 142 146.55 142Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M158.837 142H160.837V130H158.837V142Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.837 130H174.76V131.434H171.853V135.023H174.099V136.457H171.853V140.568H174.837V142H169.837V130Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M181.837 139.503C181.837 139.249 181.852 139.017 181.885 138.803C181.917 138.588 181.966 138.357 182.031 138.108H183.531V138.681C183.531 138.998 183.552 139.28 183.595 139.522C183.636 139.767 183.706 139.973 183.803 140.141C183.899 140.309 184.03 140.436 184.191 140.52C184.353 140.605 184.552 140.648 184.785 140.648C185.153 140.648 185.434 140.555 185.627 140.367C185.822 140.182 185.918 139.909 185.918 139.55C185.918 139.367 185.906 139.197 185.878 139.044C185.852 138.888 185.802 138.736 185.736 138.585C185.67 138.433 185.579 138.273 185.464 138.105C185.35 137.937 185.202 137.749 185.024 137.541L183.009 135.326C182.65 134.905 182.374 134.477 182.179 134.048C181.986 133.617 181.889 133.157 181.889 132.67C181.889 132.279 181.955 131.92 182.087 131.593C182.219 131.268 182.409 130.987 182.657 130.748C182.906 130.512 183.214 130.328 183.579 130.196C183.945 130.066 184.36 130 184.821 130C185.384 130 185.853 130.073 186.228 130.22C186.603 130.368 186.904 130.562 187.129 130.8C187.352 131.04 187.51 131.308 187.603 131.604C187.695 131.9 187.74 132.198 187.74 132.497C187.74 132.751 187.718 132.985 187.676 133.199C187.634 133.412 187.585 133.648 187.53 133.906H186.038V133.347C186.038 132.72 185.943 132.242 185.748 131.908C185.554 131.575 185.237 131.407 184.799 131.407C184.436 131.407 184.167 131.502 183.987 131.688C183.808 131.873 183.717 132.123 183.717 132.436C183.717 132.603 183.731 132.751 183.759 132.884C183.785 133.017 183.826 133.141 183.878 133.254C183.929 133.367 183.993 133.477 184.069 133.582C184.142 133.687 184.226 133.797 184.322 133.913L186.569 136.425C186.977 136.916 187.289 137.39 187.509 137.844C187.727 138.296 187.837 138.777 187.837 139.281C187.837 139.701 187.766 140.077 187.624 140.413C187.482 140.751 187.281 141.035 187.015 141.27C186.752 141.504 186.433 141.684 186.062 141.811C185.687 141.937 185.267 142 184.799 142C184.223 142 183.744 141.93 183.364 141.786C182.982 141.644 182.68 141.456 182.452 141.219C182.226 140.986 182.067 140.72 181.975 140.421C181.882 140.121 181.837 139.816 181.837 139.503Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5624 101.909L9.57734 101.297C5.75606 100.936 5.75606 99.2025 5.75606 98.5495C5.75606 96.5687 7.35596 94.9569 9.32374 94.9569H23.7087V90H9.32374C4.64302 90 0.837402 93.8355 0.837402 98.5495C0.837402 102.869 3.937 105.741 9.13588 106.233L15.9894 106.829C18.6319 107.224 19.9172 108.408 19.9172 110.45C19.9172 112.431 18.3173 114.043 16.3495 114.043H1.94261V119H16.3495C21.0302 119 24.8374 115.164 24.8374 110.45C24.8374 105.8 21.8349 102.688 16.5624 101.909Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.8374 119H51.8374V114.556H37.7663V108.223H50.6626V103.774H37.7663V95.4468H51.8374V91H32.8374V119Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.06 107.322H66.6133L70.3366 98.1027L74.06 107.322ZM68.3395 91L56.8374 119H61.8952L64.9131 111.531H75.7602L78.7765 119H83.8374L72.3337 91H68.3395Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.94 100.229C104.94 103.347 103.266 105.065 100.229 105.065H93.5619V95.4124H100.229C103.222 95.4124 104.94 97.169 104.94 100.229ZM109.667 100.226C109.667 94.6217 106.039 91 100.426 91H88.8374V119H93.565V109.476H99.2882L106.076 119H111.837L104.34 108.726C107.694 107.443 109.667 104.329 109.667 100.226Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.837 119H123.837V91H118.837V119Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M151.939 104.985C151.939 111.148 148.565 114.542 142.439 114.542H137.737V95.4607H142.439C148.477 95.4607 151.939 98.9322 151.939 104.985ZM142.439 91H132.837V119H142.439C151.32 119 156.837 113.631 156.837 104.985C156.837 96.4902 151.185 91 142.439 91Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M183.994 112.003C182.352 113.676 180.059 114.523 177.173 114.523C171.346 114.523 167.727 110.676 167.727 104.481C167.727 98.3151 171.351 94.4847 177.185 94.4847C180.199 94.4847 182.685 95.4504 184.576 97.3571L185.495 98.2808L188.777 95.2635L187.884 94.2962C185.292 91.4861 181.588 90 177.173 90C168.599 90 162.837 95.8196 162.837 104.481C162.837 113.165 168.599 119 177.173 119C182.053 119 185.99 117.252 188.559 113.945L188.837 113.588V103.655H183.994V112.003Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M213.837 95.4468V91H194.837V119H213.837V114.555H199.765V108.223H212.664V103.774H199.765V95.4468H213.837Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_697",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 61,
    y: 36,
    width: 10,
    height: 39
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.7095 44.9098V74.5529L70.4498 70.7236V36.3544L61.7095 44.9098Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_697)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.7095 44.9098V74.5529L70.4498 70.7236V36.3544L61.7095 44.9098Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_0_697",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 131,
    y: 21,
    width: 10,
    height: 48
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M131.824 64.374L140.565 68.2279V30.0509L131.824 21.4388V64.374Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_0_697)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M131.824 64.374L140.565 68.2279V30.0509L131.824 21.4388V64.374Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_0_697",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 78,
    y: 20,
    width: 9,
    height: 48
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.0835 28.6928V67.6396L86.8222 63.7506V20.0037L78.0835 28.6928Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_0_697)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.0835 28.6928V67.6396L86.8222 63.7506V20.0037L78.0835 28.6928Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_0_697",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 163,
    y: 53,
    width: 10,
    height: 27
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M163.992 79.5355C164.671 79.0004 165.262 78.3781 165.682 77.675L171.376 68.1581C172.863 65.6739 172.447 61.9484 170.454 59.8795L163.992 53.1797V79.5355Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_0_697)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M163.992 79.5355C164.671 79.0004 165.262 78.3781 165.682 77.675L171.376 68.1581C172.863 65.6739 172.447 61.9484 170.454 59.8795L163.992 53.1797V79.5355Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_0_697",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 148,
    y: 36,
    width: 9,
    height: 39
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M148.198 70.759L156.937 74.5882V45.359L148.198 36.8021V70.759Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_0_697)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M148.198 70.759L156.937 74.5882V45.359L148.198 36.8021V70.759Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_0_697",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 45,
    y: 52,
    width: 10,
    height: 25
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.872 59.9146C44.7836 61.9928 44.6972 65.4724 46.6803 67.6474L54.6475 76.3881V52.1834L46.872 59.9146Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_0_697)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.872 59.9146C44.7836 61.9928 44.6972 65.4724 46.6803 67.6474L54.6475 76.3881V52.1834L46.872 59.9146Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_0_697",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 93,
    y: 0,
    width: 32,
    height: 61
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.081 1.70004L93.8838 12.8972V60.2993L100.061 57.5357C100.485 57.2474 100.741 56.7607 100.733 56.2523L100.485 42.1085C100.434 38.0289 103.613 28.5677 108.136 28.5104H109.223C113.745 28.5677 116.925 38.0289 116.872 42.1085L116.625 56.2523C116.618 56.7607 116.872 57.2474 117.298 57.5357L124.764 60.8759V13.8923L112.574 1.70004C111.543 0.670844 110.185 0.154694 108.827 0.154694C107.47 0.154694 106.11 0.670844 105.081 1.70004Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_0_697)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.081 1.70004L93.8838 12.8972V60.2993L100.061 57.5357C100.485 57.2474 100.741 56.7607 100.733 56.2523L100.485 42.1085C100.434 38.0289 103.613 28.5677 108.136 28.5104H109.223C113.745 28.5677 116.925 38.0289 116.872 42.1085L116.625 56.2523C116.618 56.7607 116.872 57.2474 117.298 57.5357L124.764 60.8759V13.8923L112.574 1.70004C111.543 0.670844 110.185 0.154694 108.827 0.154694C107.47 0.154694 106.11 0.670844 105.081 1.70004Z",
    fill: "white"
  }))), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M131.837 168L108.064 161.4L85.8374 168V163.6L108.064 157L131.837 163.6V168Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLarge);
export default __webpack_public_path__ + "static/media/logo_large.c69db10bad97994fb492a3ad1b2363db.svg";
export { ForwardRef as ReactComponent };